import { render } from "./_2.vue?vue&type=template&id=6668243f&scoped=true"
import script from "./_2.vue?vue&type=script&lang=js"
export * from "./_2.vue?vue&type=script&lang=js"

import "./_2.vue?vue&type=style&index=0&id=6668243f&scoped=true&lang=css"

import exportComponent from "/Users/marianne/DevProjects/Marinka backup 29-08-2025/full website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6668243f"]])

export default __exports__